import React from 'react';

interface PageHeaderProps {
  title:     string;
  subtitle?: React.ReactNode;
  actions?:  React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions }) => (
  <div className="flex flex-wrap items-end justify-between gap-x-4 gap-y-3 mb-5 lg:mb-7">
    <div className="min-w-0">
      <h1 className="text-[22px] sm:text-[26px] leading-tight font-semibold text-stone-900 tracking-[-0.02em]">{title}</h1>
      {subtitle && <p className="text-[13.5px] text-stone-500 mt-1.5 max-w-3xl">{subtitle}</p>}
    </div>
    {actions && <div className="w-full sm:w-auto min-w-0 flex flex-wrap items-center gap-2">{actions}</div>}
  </div>
);
